module.exports = __webpack_public_path__ + "img/301.a474089a.jpg";